import React, { useState } from "react";
import { doPasswordReset } from "../../../firebase/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Auth.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    doPasswordReset(email)
      .then(() => {
        toast.success("Password reset email sent. Please check your inbox.");
      })
      .catch((error) => {
        const errorCode = error.code;
        let message = "";

        switch (errorCode) {
          case "auth/user-not-found":
            message = "No user found with this email.";
            break;
          case "auth/invalid-email":
            message = "Please provide a valid email address.";
            break;
          default:
            message = "An error occurred. Please try again.";
        }

        toast.error(message);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="container">
      <div className="form-container">
        <h3 className="title">Forgot Password</h3>
        <form onSubmit={handleSubmit} className="form">
          <div className="form-control">
            <label className="label">Email</label>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
            />
          </div>

          <button
            type="submit"
            className={`button ${isSubmitting ? "disabled" : ""}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send Password Reset Email"}
          </button>
        </form>

        <p className="form-footer">
          Remember your password?{" "}
          <a href="/login" className="link">
            Log in
          </a>
        </p>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default ForgotPassword;
